export const TIMEZONES = [
  {
    text: "[GMT-11:00] Pacific/Midway",
    value: "Pacific/Midway",
  },
  {
    text: "[GMT-11:00] Pacific/Niue",
    value: "Pacific/Niue",
  },
  {
    text: "[GMT-11:00] Pacific/Pago_Pago",
    value: "Pacific/Pago_Pago",
  },
  {
    text: "[GMT-11:00] Pacific/Samoa",
    value: "Pacific/Samoa",
  },
  {
    text: "[GMT-11:00] US/Samoa",
    value: "US/Samoa",
  },
  {
    text: "[GMT-10:00] Pacific/Honolulu",
    value: "Pacific/Honolulu",
  },
  {
    text: "[GMT-10:00] Pacific/Johnston",
    value: "Pacific/Johnston",
  },
  {
    text: "[GMT-10:00] Pacific/Rarotonga",
    value: "Pacific/Rarotonga",
  },
  {
    text: "[GMT-10:00] Pacific/Tahiti",
    value: "Pacific/Tahiti",
  },
  {
    text: "[GMT-10:00] US/Hawaii",
    value: "US/Hawaii",
  },
  {
    text: "[GMT-09:00] America/Adak",
    value: "America/Adak",
  },
  {
    text: "[GMT-09:00] America/Atka",
    value: "America/Atka",
  },
  {
    text: "[GMT-09:00] Pacific/Gambier",
    value: "Pacific/Gambier",
  },
  {
    text: "[GMT-09:30] Pacific/Marquesas",
    value: "Pacific/Marquesas",
  },
  {
    text: "[GMT-09:00] US/Aleutian",
    value: "US/Aleutian",
  },
  {
    text: "[GMT-08:00] America/Anchorage",
    value: "America/Anchorage",
  },
  {
    text: "[GMT-08:00] America/Juneau",
    value: "America/Juneau",
  },
  {
    text: "[GMT-08:00] America/Metlakatla",
    value: "America/Metlakatla",
  },
  {
    text: "[GMT-08:00] America/Nome",
    value: "America/Nome",
  },
  {
    text: "[GMT-08:00] America/Sitka",
    value: "America/Sitka",
  },
  {
    text: "[GMT-08:00] America/Yakutat",
    value: "America/Yakutat",
  },
  {
    text: "[GMT-08:00] Pacific/Pitcairn",
    value: "Pacific/Pitcairn",
  },
  {
    text: "[GMT-08:00] US/Alaska",
    value: "US/Alaska",
  },
  {
    text: "[GMT-07:00] America/Chihuahua",
    value: "America/Chihuahua",
  },
  {
    text: "[GMT-07:00] America/Creston",
    value: "America/Creston",
  },
  {
    text: "[GMT-07:00] America/Dawson",
    value: "America/Dawson",
  },
  {
    text: "[GMT-07:00] America/Dawson_Creek",
    value: "America/Dawson_Creek",
  },
  {
    text: "[GMT-07:00] America/Ensenada",
    value: "America/Ensenada",
  },
  {
    text: "[GMT-07:00] America/Fort_Nelson",
    value: "America/Fort_Nelson",
  },
  {
    text: "[GMT-07:00] America/Hermosillo",
    value: "America/Hermosillo",
  },
  {
    text: "[GMT-07:00] America/Los_Angeles",
    value: "America/Los_Angeles",
  },
  {
    text: "[GMT-07:00] America/Mazatlan",
    value: "America/Mazatlan",
  },
  {
    text: "[GMT-07:00] America/Phoenix",
    value: "America/Phoenix",
  },
  {
    text: "[GMT-07:00] America/Santa_Isabel",
    value: "America/Santa_Isabel",
  },
  {
    text: "[GMT-07:00] America/Tijuana",
    value: "America/Tijuana",
  },
  {
    text: "[GMT-07:00] America/Vancouver",
    value: "America/Vancouver",
  },
  {
    text: "[GMT-07:00] America/Whitehorse",
    value: "America/Whitehorse",
  },
  {
    text: "[GMT-07:00] Canada/Pacific",
    value: "Canada/Pacific",
  },
  {
    text: "[GMT-07:00] Canada/Yukon",
    value: "Canada/Yukon",
  },
  {
    text: "[GMT-07:00] Mexico/BajaNorte",
    value: "Mexico/BajaNorte",
  },
  {
    text: "[GMT-07:00] Mexico/BajaSur",
    value: "Mexico/BajaSur",
  },
  {
    text: "[GMT-07:00] US/Arizona",
    value: "US/Arizona",
  },
  {
    text: "[GMT-07:00] US/Pacific",
    value: "US/Pacific",
  },
  {
    text: "[GMT-07:00] US/Pacific-New",
    value: "US/Pacific-New",
  },
  {
    text: "[GMT-06:00] America/Bahia_Banderas",
    value: "America/Bahia_Banderas",
  },
  {
    text: "[GMT-06:00] America/Belize",
    value: "America/Belize",
  },
  {
    text: "[GMT-06:00] America/Boise",
    value: "America/Boise",
  },
  {
    text: "[GMT-06:00] America/Cambridge_Bay",
    value: "America/Cambridge_Bay",
  },
  {
    text: "[GMT-06:00] America/Costa_Rica",
    value: "America/Costa_Rica",
  },
  {
    text: "[GMT-06:00] America/Denver",
    value: "America/Denver",
  },
  {
    text: "[GMT-06:00] America/Edmonton",
    value: "America/Edmonton",
  },
  {
    text: "[GMT-06:00] America/El_Salvador",
    value: "America/El_Salvador",
  },
  {
    text: "[GMT-06:00] America/Guatemala",
    value: "America/Guatemala",
  },
  {
    text: "[GMT-06:00] America/Inuvik",
    value: "America/Inuvik",
  },
  {
    text: "[GMT-06:00] America/Managua",
    value: "America/Managua",
  },
  {
    text: "[GMT-06:00] America/Merida",
    value: "America/Merida",
  },
  {
    text: "[GMT-06:00] America/Mexico_City",
    value: "America/Mexico_City",
  },
  {
    text: "[GMT-06:00] America/Monterrey",
    value: "America/Monterrey",
  },
  {
    text: "[GMT-06:00] America/Ojinaga",
    value: "America/Ojinaga",
  },
  {
    text: "[GMT-06:00] America/Regina",
    value: "America/Regina",
  },
  {
    text: "[GMT-06:00] America/Shiprock",
    value: "America/Shiprock",
  },
  {
    text: "[GMT-06:00] America/Swift_Current",
    value: "America/Swift_Current",
  },
  {
    text: "[GMT-06:00] America/Tegucigalpa",
    value: "America/Tegucigalpa",
  },
  {
    text: "[GMT-06:00] America/Yellowknife",
    value: "America/Yellowknife",
  },
  {
    text: "[GMT-06:00] Canada/Mountain",
    value: "Canada/Mountain",
  },
  {
    text: "[GMT-06:00] Canada/Saskatchewan",
    value: "Canada/Saskatchewan",
  },
  {
    text: "[GMT-06:00] Mexico/General",
    value: "Mexico/General",
  },
  {
    text: "[GMT-06:00] Pacific/Galapagos",
    value: "Pacific/Galapagos",
  },
  {
    text: "[GMT-06:00] US/Mountain",
    value: "US/Mountain",
  },
  {
    text: "[GMT-05:00] America/Atikokan",
    value: "America/Atikokan",
  },
  {
    text: "[GMT-05:00] America/Bogota",
    value: "America/Bogota",
  },
  {
    text: "[GMT-05:00] America/Cancun",
    value: "America/Cancun",
  },
  {
    text: "[GMT-05:00] America/Cayman",
    value: "America/Cayman",
  },
  {
    text: "[GMT-05:00] America/Chicago",
    value: "America/Chicago",
  },
  {
    text: "[GMT-05:00] America/Coral_Harbour",
    value: "America/Coral_Harbour",
  },
  {
    text: "[GMT-05:00] America/Eirunepe",
    value: "America/Eirunepe",
  },
  {
    text: "[GMT-05:00] America/Guayaquil",
    value: "America/Guayaquil",
  },
  {
    text: "[GMT-05:00] America/Indiana/Knox",
    value: "America/Indiana/Knox",
  },
  {
    text: "[GMT-05:00] America/Indiana/Tell_City",
    value: "America/Indiana/Tell_City",
  },
  {
    text: "[GMT-05:00] America/Jamaica",
    value: "America/Jamaica",
  },
  {
    text: "[GMT-05:00] America/Knox_IN",
    value: "America/Knox_IN",
  },
  {
    text: "[GMT-05:00] America/Lima",
    value: "America/Lima",
  },
  {
    text: "[GMT-05:00] America/Matamoros",
    value: "America/Matamoros",
  },
  {
    text: "[GMT-05:00] America/Menominee",
    value: "America/Menominee",
  },
  {
    text: "[GMT-05:00] America/North_Dakota/Beulah",
    value: "America/North_Dakota/Beulah",
  },
  {
    text: "[GMT-05:00] America/North_Dakota/Center",
    value: "America/North_Dakota/Center",
  },
  {
    text: "[GMT-05:00] America/North_Dakota/New_Salem",
    value: "America/North_Dakota/New_Salem",
  },
  {
    text: "[GMT-05:00] America/Panama",
    value: "America/Panama",
  },
  {
    text: "[GMT-05:00] America/Porto_Acre",
    value: "America/Porto_Acre",
  },
  {
    text: "[GMT-05:00] America/Rainy_River",
    value: "America/Rainy_River",
  },
  {
    text: "[GMT-05:00] America/Rankin_Inlet",
    value: "America/Rankin_Inlet",
  },
  {
    text: "[GMT-05:00] America/Resolute",
    value: "America/Resolute",
  },
  {
    text: "[GMT-05:00] America/Rio_Branco",
    value: "America/Rio_Branco",
  },
  {
    text: "[GMT-05:00] America/Winnipeg",
    value: "America/Winnipeg",
  },
  {
    text: "[GMT-05:00] Brazil/Acre",
    value: "Brazil/Acre",
  },
  {
    text: "[GMT-05:00] Canada/Central",
    value: "Canada/Central",
  },
  {
    text: "[GMT-05:00] Chile/EasterIsland",
    value: "Chile/EasterIsland",
  },
  {
    text: "[GMT-05:00] Pacific/Easter",
    value: "Pacific/Easter",
  },
  {
    text: "[GMT-05:00] US/Central",
    value: "US/Central",
  },
  {
    text: "[GMT-05:00] US/Indiana-Starke",
    value: "US/Indiana-Starke",
  },
  {
    text: "[GMT-04:00] America/Anguilla",
    value: "America/Anguilla",
  },
  {
    text: "[GMT-04:00] America/Antigua",
    value: "America/Antigua",
  },
  {
    text: "[GMT-04:00] America/Aruba",
    value: "America/Aruba",
  },
  {
    text: "[GMT-04:00] America/Barbados",
    value: "America/Barbados",
  },
  {
    text: "[GMT-04:00] America/Blanc-Sablon",
    value: "America/Blanc-Sablon",
  },
  {
    text: "[GMT-04:00] America/Boa_Vista",
    value: "America/Boa_Vista",
  },
  {
    text: "[GMT-04:00] America/Campo_Grande",
    value: "America/Campo_Grande",
  },
  {
    text: "[GMT-04:00] America/Caracas",
    value: "America/Caracas",
  },
  {
    text: "[GMT-04:00] America/Cuiaba",
    value: "America/Cuiaba",
  },
  {
    text: "[GMT-04:00] America/Curacao",
    value: "America/Curacao",
  },
  {
    text: "[GMT-04:00] America/Detroit",
    value: "America/Detroit",
  },
  {
    text: "[GMT-04:00] America/Dominica",
    value: "America/Dominica",
  },
  {
    text: "[GMT-04:00] America/Fort_Wayne",
    value: "America/Fort_Wayne",
  },
  {
    text: "[GMT-04:00] America/Grand_Turk",
    value: "America/Grand_Turk",
  },
  {
    text: "[GMT-04:00] America/Grenada",
    value: "America/Grenada",
  },
  {
    text: "[GMT-04:00] America/Guadeloupe",
    value: "America/Guadeloupe",
  },
  {
    text: "[GMT-04:00] America/Guyana",
    value: "America/Guyana",
  },
  {
    text: "[GMT-04:00] America/Havana",
    value: "America/Havana",
  },
  {
    text: "[GMT-04:00] America/Indiana/Indianapolis",
    value: "America/Indiana/Indianapolis",
  },
  {
    text: "[GMT-04:00] America/Indiana/Marengo",
    value: "America/Indiana/Marengo",
  },
  {
    text: "[GMT-04:00] America/Indiana/Petersburg",
    value: "America/Indiana/Petersburg",
  },
  {
    text: "[GMT-04:00] America/Indiana/Vevay",
    value: "America/Indiana/Vevay",
  },
  {
    text: "[GMT-04:00] America/Indiana/Vincennes",
    value: "America/Indiana/Vincennes",
  },
  {
    text: "[GMT-04:00] America/Indiana/Winamac",
    value: "America/Indiana/Winamac",
  },
  {
    text: "[GMT-04:00] America/Indianapolis",
    value: "America/Indianapolis",
  },
  {
    text: "[GMT-04:00] America/Iqaluit",
    value: "America/Iqaluit",
  },
  {
    text: "[GMT-04:00] America/Kentucky/Louisville",
    value: "America/Kentucky/Louisville",
  },
  {
    text: "[GMT-04:00] America/Kentucky/Monticello",
    value: "America/Kentucky/Monticello",
  },
  {
    text: "[GMT-04:00] America/Kralendijk",
    value: "America/Kralendijk",
  },
  {
    text: "[GMT-04:00] America/La_Paz",
    value: "America/La_Paz",
  },
  {
    text: "[GMT-04:00] America/Louisville",
    value: "America/Louisville",
  },
  {
    text: "[GMT-04:00] America/Lower_Princes",
    value: "America/Lower_Princes",
  },
  {
    text: "[GMT-04:00] America/Manaus",
    value: "America/Manaus",
  },
  {
    text: "[GMT-04:00] America/Marigot",
    value: "America/Marigot",
  },
  {
    text: "[GMT-04:00] America/Martinique",
    value: "America/Martinique",
  },
  {
    text: "[GMT-04:00] America/Montreal",
    value: "America/Montreal",
  },
  {
    text: "[GMT-04:00] America/Montserrat",
    value: "America/Montserrat",
  },
  {
    text: "[GMT-04:00] America/Nassau",
    value: "America/Nassau",
  },
  {
    text: "[GMT-04:00] America/New_York",
    value: "America/New_York",
  },
  {
    text: "[GMT-04:00] America/Nipigon",
    value: "America/Nipigon",
  },
  {
    text: "[GMT-04:00] America/Pangnirtung",
    value: "America/Pangnirtung",
  },
  {
    text: "[GMT-04:00] America/Port-au-Prince",
    value: "America/Port-au-Prince",
  },
  {
    text: "[GMT-04:00] America/Port_of_Spain",
    value: "America/Port_of_Spain",
  },
  {
    text: "[GMT-04:00] America/Porto_Velho",
    value: "America/Porto_Velho",
  },
  {
    text: "[GMT-04:00] America/Puerto_Rico",
    value: "America/Puerto_Rico",
  },
  {
    text: "[GMT-04:00] America/Santo_Domingo",
    value: "America/Santo_Domingo",
  },
  {
    text: "[GMT-04:00] America/St_Barthelemy",
    value: "America/St_Barthelemy",
  },
  {
    text: "[GMT-04:00] America/St_Kitts",
    value: "America/St_Kitts",
  },
  {
    text: "[GMT-04:00] America/St_Lucia",
    value: "America/St_Lucia",
  },
  {
    text: "[GMT-04:00] America/St_Thomas",
    value: "America/St_Thomas",
  },
  {
    text: "[GMT-04:00] America/St_Vincent",
    value: "America/St_Vincent",
  },
  {
    text: "[GMT-04:00] America/Thunder_Bay",
    value: "America/Thunder_Bay",
  },
  {
    text: "[GMT-04:00] America/Toronto",
    value: "America/Toronto",
  },
  {
    text: "[GMT-04:00] America/Tortola",
    value: "America/Tortola",
  },
  {
    text: "[GMT-04:00] America/Virgin",
    value: "America/Virgin",
  },
  {
    text: "[GMT-04:00] Brazil/West",
    value: "Brazil/West",
  },
  {
    text: "[GMT-04:00] Canada/Eastern",
    value: "Canada/Eastern",
  },
  {
    text: "[GMT-04:00] US/East-Indiana",
    value: "US/East-Indiana",
  },
  {
    text: "[GMT-04:00] US/Eastern",
    value: "US/Eastern",
  },
  {
    text: "[GMT-04:00] US/Michigan",
    value: "US/Michigan",
  },
  {
    text: "[GMT-03:00] America/Araguaina",
    value: "America/Araguaina",
  },
  {
    text: "[GMT-03:00] America/Argentina/Buenos_Aires",
    value: "America/Argentina/Buenos_Aires",
  },
  {
    text: "[GMT-03:00] America/Argentina/Catamarca",
    value: "America/Argentina/Catamarca",
  },
  {
    text: "[GMT-03:00] America/Argentina/ComodRivadavia",
    value: "America/Argentina/ComodRivadavia",
  },
  {
    text: "[GMT-03:00] America/Argentina/Cordoba",
    value: "America/Argentina/Cordoba",
  },
  {
    text: "[GMT-03:00] America/Argentina/Jujuy",
    value: "America/Argentina/Jujuy",
  },
  {
    text: "[GMT-03:00] America/Argentina/La_Rioja",
    value: "America/Argentina/La_Rioja",
  },
  {
    text: "[GMT-03:00] America/Argentina/Mendoza",
    value: "America/Argentina/Mendoza",
  },
  {
    text: "[GMT-03:00] America/Argentina/Rio_Gallegos",
    value: "America/Argentina/Rio_Gallegos",
  },
  {
    text: "[GMT-03:00] America/Argentina/Salta",
    value: "America/Argentina/Salta",
  },
  {
    text: "[GMT-03:00] America/Argentina/San_Juan",
    value: "America/Argentina/San_Juan",
  },
  {
    text: "[GMT-03:00] America/Argentina/San_Luis",
    value: "America/Argentina/San_Luis",
  },
  {
    text: "[GMT-03:00] America/Argentina/Tucuman",
    value: "America/Argentina/Tucuman",
  },
  {
    text: "[GMT-03:00] America/Argentina/Ushuaia",
    value: "America/Argentina/Ushuaia",
  },
  {
    text: "[GMT-03:00] America/Asuncion",
    value: "America/Asuncion",
  },
  {
    text: "[GMT-03:00] America/Bahia",
    value: "America/Bahia",
  },
  {
    text: "[GMT-03:00] America/Belem",
    value: "America/Belem",
  },
  {
    text: "[GMT-03:00] America/Buenos_Aires",
    value: "America/Buenos_Aires",
  },
  {
    text: "[GMT-03:00] America/Catamarca",
    value: "America/Catamarca",
  },
  {
    text: "[GMT-03:00] America/Cayenne",
    value: "America/Cayenne",
  },
  {
    text: "[GMT-03:00] America/Cordoba",
    value: "America/Cordoba",
  },
  {
    text: "[GMT-03:00] America/Fortaleza",
    value: "America/Fortaleza",
  },
  {
    text: "[GMT-03:00] America/Glace_Bay",
    value: "America/Glace_Bay",
  },
  {
    text: "[GMT-03:00] America/Godthab",
    value: "America/Godthab",
  },
  {
    text: "[GMT-03:00] America/Goose_Bay",
    value: "America/Goose_Bay",
  },
  {
    text: "[GMT-03:00] America/Halifax",
    value: "America/Halifax",
  },
  {
    text: "[GMT-03:00] America/Jujuy",
    value: "America/Jujuy",
  },
  {
    text: "[GMT-03:00] America/Maceio",
    value: "America/Maceio",
  },
  {
    text: "[GMT-03:00] America/Mendoza",
    value: "America/Mendoza",
  },
  {
    text: "[GMT-03:00] America/Moncton",
    value: "America/Moncton",
  },
  {
    text: "[GMT-03:00] America/Montevideo",
    value: "America/Montevideo",
  },
  {
    text: "[GMT-03:00] America/Paramaribo",
    value: "America/Paramaribo",
  },
  {
    text: "[GMT-03:00] America/Punta_Arenas",
    value: "America/Punta_Arenas",
  },
  {
    text: "[GMT-03:00] America/Recife",
    value: "America/Recife",
  },
  {
    text: "[GMT-03:00] America/Rosario",
    value: "America/Rosario",
  },
  {
    text: "[GMT-03:00] America/Santarem",
    value: "America/Santarem",
  },
  {
    text: "[GMT-03:00] America/Santiago",
    value: "America/Santiago",
  },
  {
    text: "[GMT-03:00] America/Sao_Paulo",
    value: "America/Sao_Paulo",
  },
  {
    text: "[GMT-03:00] America/Thule",
    value: "America/Thule",
  },
  {
    text: "[GMT-03:00] Antarctica/Palmer",
    value: "Antarctica/Palmer",
  },
  {
    text: "[GMT-03:00] Antarctica/Rothera",
    value: "Antarctica/Rothera",
  },
  {
    text: "[GMT-03:00] Atlantic/Bermuda",
    value: "Atlantic/Bermuda",
  },
  {
    text: "[GMT-03:00] Atlantic/Stanley",
    value: "Atlantic/Stanley",
  },
  {
    text: "[GMT-03:00] Brazil/East",
    value: "Brazil/East",
  },
  {
    text: "[GMT-03:00] Canada/Atlantic",
    value: "Canada/Atlantic",
  },
  {
    text: "[GMT-03:00] Chile/Continental",
    value: "Chile/Continental",
  },
  {
    text: "[GMT-02:00] America/Miquelon",
    value: "America/Miquelon",
  },
  {
    text: "[GMT-02:00] America/Noronha",
    value: "America/Noronha",
  },
  {
    text: "[GMT-02:30] America/St_Johns",
    value: "America/St_Johns",
  },
  {
    text: "[GMT-02:00] Atlantic/South_Georgia",
    value: "Atlantic/South_Georgia",
  },
  {
    text: "[GMT-02:00] Brazil/DeNoronha",
    value: "Brazil/DeNoronha",
  },
  {
    text: "[GMT-02:30] Canada/Newfoundland",
    value: "Canada/Newfoundland",
  },
  {
    text: "[GMT-01:00] America/Scoresbysund",
    value: "America/Scoresbysund",
  },
  {
    text: "[GMT-01:00] Atlantic/Azores",
    value: "Atlantic/Azores",
  },
  {
    text: "[GMT-01:00] Atlantic/Cape_Verde",
    value: "Atlantic/Cape_Verde",
  },
  {
    text: "[GMT+00:00] Africa/Abidjan",
    value: "Africa/Abidjan",
  },
  {
    text: "[GMT+00:00] Africa/Accra",
    value: "Africa/Accra",
  },
  {
    text: "[GMT+00:00] Africa/Bamako",
    value: "Africa/Bamako",
  },
  {
    text: "[GMT+00:00] Africa/Banjul",
    value: "Africa/Banjul",
  },
  {
    text: "[GMT+00:00] Africa/Bissau",
    value: "Africa/Bissau",
  },
  {
    text: "[GMT+00:00] Africa/Casablanca",
    value: "Africa/Casablanca",
  },
  {
    text: "[GMT+00:00] Africa/Conakry",
    value: "Africa/Conakry",
  },
  {
    text: "[GMT+00:00] Africa/Dakar",
    value: "Africa/Dakar",
  },
  {
    text: "[GMT+00:00] Africa/El_Aaiun",
    value: "Africa/El_Aaiun",
  },
  {
    text: "[GMT+00:00] Africa/Freetown",
    value: "Africa/Freetown",
  },
  {
    text: "[GMT+00:00] Africa/Lome",
    value: "Africa/Lome",
  },
  {
    text: "[GMT+00:00] Africa/Monrovia",
    value: "Africa/Monrovia",
  },
  {
    text: "[GMT+00:00] Africa/Nouakchott",
    value: "Africa/Nouakchott",
  },
  {
    text: "[GMT+00:00] Africa/Ouagadougou",
    value: "Africa/Ouagadougou",
  },
  {
    text: "[GMT+00:00] Africa/Timbuktu",
    value: "Africa/Timbuktu",
  },
  {
    text: "[GMT+00:00] America/Danmarkshavn",
    value: "America/Danmarkshavn",
  },
  {
    text: "[GMT+00:00] Antarctica/Troll",
    value: "Antarctica/Troll",
  },
  {
    text: "[GMT+00:00] Atlantic/Canary",
    value: "Atlantic/Canary",
  },
  {
    text: "[GMT+00:00] Atlantic/Faeroe",
    value: "Atlantic/Faeroe",
  },
  {
    text: "[GMT+00:00] Atlantic/Faroe",
    value: "Atlantic/Faroe",
  },
  {
    text: "[GMT+00:00] Atlantic/Madeira",
    value: "Atlantic/Madeira",
  },
  {
    text: "[GMT+00:00] Atlantic/Reykjavik",
    value: "Atlantic/Reykjavik",
  },
  {
    text: "[GMT+00:00] Atlantic/St_Helena",
    value: "Atlantic/St_Helena",
  },
  {
    text: "[GMT+00:00] Etc/Greenwich",
    value: "Etc/Greenwich",
  },
  {
    text: "[GMT+00:00] Etc/UCT",
    value: "Etc/UCT",
  },
  {
    text: "[GMT+00:00] Etc/UTC",
    value: "Etc/UTC",
  },
  {
    text: "[GMT+00:00] Etc/Universal",
    value: "Etc/Universal",
  },
  {
    text: "[GMT+00:00] Etc/Zulu",
    value: "Etc/Zulu",
  },
  {
    text: "[GMT+00:00] Europe/Belfast",
    value: "Europe/Belfast",
  },
  {
    text: "[GMT+00:00] Europe/Dublin",
    value: "Europe/Dublin",
  },
  {
    text: "[GMT+00:00] Europe/Guernsey",
    value: "Europe/Guernsey",
  },
  {
    text: "[GMT+00:00] Europe/Isle_of_Man",
    value: "Europe/Isle_of_Man",
  },
  {
    text: "[GMT+00:00] Europe/Jersey",
    value: "Europe/Jersey",
  },
  {
    text: "[GMT+00:00] Europe/Lisbon",
    value: "Europe/Lisbon",
  },
  {
    text: "[GMT+00:00] Europe/London",
    value: "Europe/London",
  },
  {
    text: "[GMT+01:00] Africa/Algiers",
    value: "Africa/Algiers",
  },
  {
    text: "[GMT+01:00] Africa/Bangui",
    value: "Africa/Bangui",
  },
  {
    text: "[GMT+01:00] Africa/Brazzaville",
    value: "Africa/Brazzaville",
  },
  {
    text: "[GMT+01:00] Africa/Ceuta",
    value: "Africa/Ceuta",
  },
  {
    text: "[GMT+01:00] Africa/Douala",
    value: "Africa/Douala",
  },
  {
    text: "[GMT+01:00] Africa/Kinshasa",
    value: "Africa/Kinshasa",
  },
  {
    text: "[GMT+01:00] Africa/Lagos",
    value: "Africa/Lagos",
  },
  {
    text: "[GMT+01:00] Africa/Libreville",
    value: "Africa/Libreville",
  },
  {
    text: "[GMT+01:00] Africa/Luanda",
    value: "Africa/Luanda",
  },
  {
    text: "[GMT+01:00] Africa/Malabo",
    value: "Africa/Malabo",
  },
  {
    text: "[GMT+01:00] Africa/Ndjamena",
    value: "Africa/Ndjamena",
  },
  {
    text: "[GMT+01:00] Africa/Niamey",
    value: "Africa/Niamey",
  },
  {
    text: "[GMT+01:00] Africa/Porto-Novo",
    value: "Africa/Porto-Novo",
  },
  {
    text: "[GMT+01:00] Africa/Sao_Tome",
    value: "Africa/Sao_Tome",
  },
  {
    text: "[GMT+01:00] Africa/Tunis",
    value: "Africa/Tunis",
  },
  {
    text: "[GMT+01:00] Arctic/Longyearbyen",
    value: "Arctic/Longyearbyen",
  },
  {
    text: "[GMT+01:00] Atlantic/Jan_Mayen",
    value: "Atlantic/Jan_Mayen",
  },
  {
    text: "[GMT+01:00] Europe/Amsterdam",
    value: "Europe/Amsterdam",
  },
  {
    text: "[GMT+01:00] Europe/Andorra",
    value: "Europe/Andorra",
  },
  {
    text: "[GMT+01:00] Europe/Belgrade",
    value: "Europe/Belgrade",
  },
  {
    text: "[GMT+01:00] Europe/Berlin",
    value: "Europe/Berlin",
  },
  {
    text: "[GMT+01:00] Europe/Bratislava",
    value: "Europe/Bratislava",
  },
  {
    text: "[GMT+01:00] Europe/Brussels",
    value: "Europe/Brussels",
  },
  {
    text: "[GMT+01:00] Europe/Budapest",
    value: "Europe/Budapest",
  },
  {
    text: "[GMT+01:00] Europe/Busingen",
    value: "Europe/Busingen",
  },
  {
    text: "[GMT+01:00] Europe/Copenhagen",
    value: "Europe/Copenhagen",
  },
  {
    text: "[GMT+01:00] Europe/Gibraltar",
    value: "Europe/Gibraltar",
  },
  {
    text: "[GMT+01:00] Europe/Ljubljana",
    value: "Europe/Ljubljana",
  },
  {
    text: "[GMT+01:00] Europe/Luxembourg",
    value: "Europe/Luxembourg",
  },
  {
    text: "[GMT+01:00] Europe/Madrid",
    value: "Europe/Madrid",
  },
  {
    text: "[GMT+01:00] Europe/Malta",
    value: "Europe/Malta",
  },
  {
    text: "[GMT+01:00] Europe/Monaco",
    value: "Europe/Monaco",
  },
  {
    text: "[GMT+01:00] Europe/Oslo",
    value: "Europe/Oslo",
  },
  {
    text: "[GMT+01:00] Europe/Paris",
    value: "Europe/Paris",
  },
  {
    text: "[GMT+01:00] Europe/Podgorica",
    value: "Europe/Podgorica",
  },
  {
    text: "[GMT+01:00] Europe/Prague",
    value: "Europe/Prague",
  },
  {
    text: "[GMT+01:00] Europe/Rome",
    value: "Europe/Rome",
  },
  {
    text: "[GMT+01:00] Europe/San_Marino",
    value: "Europe/San_Marino",
  },
  {
    text: "[GMT+01:00] Europe/Sarajevo",
    value: "Europe/Sarajevo",
  },
  {
    text: "[GMT+01:00] Europe/Skopje",
    value: "Europe/Skopje",
  },
  {
    text: "[GMT+01:00] Europe/Stockholm",
    value: "Europe/Stockholm",
  },
  {
    text: "[GMT+01:00] Europe/Tirane",
    value: "Europe/Tirane",
  },
  {
    text: "[GMT+01:00] Europe/Vaduz",
    value: "Europe/Vaduz",
  },
  {
    text: "[GMT+01:00] Europe/Vatican",
    value: "Europe/Vatican",
  },
  {
    text: "[GMT+01:00] Europe/Vienna",
    value: "Europe/Vienna",
  },
  {
    text: "[GMT+01:00] Europe/Warsaw",
    value: "Europe/Warsaw",
  },
  {
    text: "[GMT+01:00] Europe/Zagreb",
    value: "Europe/Zagreb",
  },
  {
    text: "[GMT+01:00] Europe/Zurich",
    value: "Europe/Zurich",
  },
  {
    text: "[GMT+02:00] Africa/Blantyre",
    value: "Africa/Blantyre",
  },
  {
    text: "[GMT+02:00] Africa/Bujumbura",
    value: "Africa/Bujumbura",
  },
  {
    text: "[GMT+02:00] Africa/Cairo",
    value: "Africa/Cairo",
  },
  {
    text: "[GMT+02:00] Africa/Gaborone",
    value: "Africa/Gaborone",
  },
  {
    text: "[GMT+02:00] Africa/Harare",
    value: "Africa/Harare",
  },
  {
    text: "[GMT+02:00] Africa/Johannesburg",
    value: "Africa/Johannesburg",
  },
  {
    text: "[GMT+02:00] Africa/Khartoum",
    value: "Africa/Khartoum",
  },
  {
    text: "[GMT+02:00] Africa/Kigali",
    value: "Africa/Kigali",
  },
  {
    text: "[GMT+02:00] Africa/Lubumbashi",
    value: "Africa/Lubumbashi",
  },
  {
    text: "[GMT+02:00] Africa/Lusaka",
    value: "Africa/Lusaka",
  },
  {
    text: "[GMT+02:00] Africa/Maputo",
    value: "Africa/Maputo",
  },
  {
    text: "[GMT+02:00] Africa/Maseru",
    value: "Africa/Maseru",
  },
  {
    text: "[GMT+02:00] Africa/Mbabane",
    value: "Africa/Mbabane",
  },
  {
    text: "[GMT+02:00] Africa/Tripoli",
    value: "Africa/Tripoli",
  },
  {
    text: "[GMT+02:00] Africa/Windhoek",
    value: "Africa/Windhoek",
  },
  {
    text: "[GMT+02:00] Asia/Beirut",
    value: "Asia/Beirut",
  },
  {
    text: "[GMT+02:00] Asia/Famagusta",
    value: "Asia/Famagusta",
  },
  {
    text: "[GMT+02:00] Asia/Jerusalem",
    value: "Asia/Jerusalem",
  },
  {
    text: "[GMT+02:00] Asia/Nicosia",
    value: "Asia/Nicosia",
  },
  {
    text: "[GMT+02:00] Asia/Tel_Aviv",
    value: "Asia/Tel_Aviv",
  },
  {
    text: "[GMT+02:00] Europe/Athens",
    value: "Europe/Athens",
  },
  {
    text: "[GMT+02:00] Europe/Bucharest",
    value: "Europe/Bucharest",
  },
  {
    text: "[GMT+02:00] Europe/Chisinau",
    value: "Europe/Chisinau",
  },
  {
    text: "[GMT+02:00] Europe/Helsinki",
    value: "Europe/Helsinki",
  },
  {
    text: "[GMT+02:00] Europe/Kaliningrad",
    value: "Europe/Kaliningrad",
  },
  {
    text: "[GMT+02:00] Europe/Kiev",
    value: "Europe/Kiev",
  },
  {
    text: "[GMT+02:00] Europe/Mariehamn",
    value: "Europe/Mariehamn",
  },
  {
    text: "[GMT+02:00] Europe/Nicosia",
    value: "Europe/Nicosia",
  },
  {
    text: "[GMT+02:00] Europe/Riga",
    value: "Europe/Riga",
  },
  {
    text: "[GMT+02:00] Europe/Sofia",
    value: "Europe/Sofia",
  },
  {
    text: "[GMT+02:00] Europe/Tallinn",
    value: "Europe/Tallinn",
  },
  {
    text: "[GMT+02:00] Europe/Tiraspol",
    value: "Europe/Tiraspol",
  },
  {
    text: "[GMT+02:00] Europe/Uzhgorod",
    value: "Europe/Uzhgorod",
  },
  {
    text: "[GMT+02:00] Europe/Vilnius",
    value: "Europe/Vilnius",
  },
  {
    text: "[GMT+02:00] Europe/Zaporozhye",
    value: "Europe/Zaporozhye",
  },
  {
    text: "[GMT+03:00] Africa/Addis_Ababa",
    value: "Africa/Addis_Ababa",
  },
  {
    text: "[GMT+03:00] Africa/Asmara",
    value: "Africa/Asmara",
  },
  {
    text: "[GMT+03:00] Africa/Asmera",
    value: "Africa/Asmera",
  },
  {
    text: "[GMT+03:00] Africa/Dar_es_Salaam",
    value: "Africa/Dar_es_Salaam",
  },
  {
    text: "[GMT+03:00] Africa/Djibouti",
    value: "Africa/Djibouti",
  },
  {
    text: "[GMT+03:00] Africa/Juba",
    value: "Africa/Juba",
  },
  {
    text: "[GMT+03:00] Africa/Kampala",
    value: "Africa/Kampala",
  },
  {
    text: "[GMT+03:00] Africa/Mogadishu",
    value: "Africa/Mogadishu",
  },
  {
    text: "[GMT+03:00] Africa/Nairobi",
    value: "Africa/Nairobi",
  },
  {
    text: "[GMT+03:00] Antarctica/Syowa",
    value: "Antarctica/Syowa",
  },
  {
    text: "[GMT+03:00] Asia/Aden",
    value: "Asia/Aden",
  },
  {
    text: "[GMT+03:00] Asia/Amman",
    value: "Asia/Amman",
  },
  {
    text: "[GMT+03:00] Asia/Baghdad",
    value: "Asia/Baghdad",
  },
  {
    text: "[GMT+03:00] Asia/Bahrain",
    value: "Asia/Bahrain",
  },
  {
    text: "[GMT+03:00] Asia/Damascus",
    value: "Asia/Damascus",
  },
  {
    text: "[GMT+03:00] Asia/Gaza",
    value: "Asia/Gaza",
  },
  {
    text: "[GMT+03:00] Asia/Hebron",
    value: "Asia/Hebron",
  },
  {
    text: "[GMT+03:00] Asia/Istanbul",
    value: "Asia/Istanbul",
  },
  {
    text: "[GMT+03:00] Asia/Kuwait",
    value: "Asia/Kuwait",
  },
  {
    text: "[GMT+03:00] Asia/Qatar",
    value: "Asia/Qatar",
  },
  {
    text: "[GMT+03:00] Asia/Riyadh",
    value: "Asia/Riyadh",
  },
  {
    text: "[GMT+03:30] Asia/Tehran",
    value: "Asia/Tehran",
  },
  {
    text: "[GMT+03:00] Europe/Istanbul",
    value: "Europe/Istanbul",
  },
  {
    text: "[GMT+03:00] Europe/Kirov",
    value: "Europe/Kirov",
  },
  {
    text: "[GMT+03:00] Europe/Minsk",
    value: "Europe/Minsk",
  },
  {
    text: "[GMT+03:00] Europe/Moscow",
    value: "Europe/Moscow",
  },
  {
    text: "[GMT+03:00] Europe/Simferopol",
    value: "Europe/Simferopol",
  },
  {
    text: "[GMT+03:00] Europe/Volgograd",
    value: "Europe/Volgograd",
  },
  {
    text: "[GMT+03:00] Indian/Antananarivo",
    value: "Indian/Antananarivo",
  },
  {
    text: "[GMT+03:00] Indian/Comoro",
    value: "Indian/Comoro",
  },
  {
    text: "[GMT+03:00] Indian/Mayotte",
    value: "Indian/Mayotte",
  },
  {
    text: "[GMT+04:00] Asia/Baku",
    value: "Asia/Baku",
  },
  {
    text: "[GMT+04:00] Asia/Dubai",
    value: "Asia/Dubai",
  },
  {
    text: "[GMT+04:30] Asia/Kabul",
    value: "Asia/Kabul",
  },
  {
    text: "[GMT+04:00] Asia/Muscat",
    value: "Asia/Muscat",
  },
  {
    text: "[GMT+04:00] Asia/Tbilisi",
    value: "Asia/Tbilisi",
  },
  {
    text: "[GMT+04:00] Asia/Yerevan",
    value: "Asia/Yerevan",
  },
  {
    text: "[GMT+04:00] Europe/Astrakhan",
    value: "Europe/Astrakhan",
  },
  {
    text: "[GMT+04:00] Europe/Samara",
    value: "Europe/Samara",
  },
  {
    text: "[GMT+04:00] Europe/Saratov",
    value: "Europe/Saratov",
  },
  {
    text: "[GMT+04:00] Europe/Ulyanovsk",
    value: "Europe/Ulyanovsk",
  },
  {
    text: "[GMT+04:00] Indian/Mahe",
    value: "Indian/Mahe",
  },
  {
    text: "[GMT+04:00] Indian/Mauritius",
    value: "Indian/Mauritius",
  },
  {
    text: "[GMT+04:00] Indian/Reunion",
    value: "Indian/Reunion",
  },
  {
    text: "[GMT+05:00] Antarctica/Mawson",
    value: "Antarctica/Mawson",
  },
  {
    text: "[GMT+05:00] Asia/Aqtau",
    value: "Asia/Aqtau",
  },
  {
    text: "[GMT+05:00] Asia/Aqtobe",
    value: "Asia/Aqtobe",
  },
  {
    text: "[GMT+05:00] Asia/Ashgabat",
    value: "Asia/Ashgabat",
  },
  {
    text: "[GMT+05:00] Asia/Ashkhabad",
    value: "Asia/Ashkhabad",
  },
  {
    text: "[GMT+05:00] Asia/Atyrau",
    value: "Asia/Atyrau",
  },
  {
    text: "[GMT+05:30] Asia/Calcutta",
    value: "Asia/Calcutta",
  },
  {
    text: "[GMT+05:30] Asia/Colombo",
    value: "Asia/Colombo",
  },
  {
    text: "[GMT+05:00] Asia/Dushanbe",
    value: "Asia/Dushanbe",
  },
  {
    text: "[GMT+05:00] Asia/Karachi",
    value: "Asia/Karachi",
  },
  {
    text: "[GMT+05:45] Asia/Kathmandu",
    value: "Asia/Kathmandu",
  },
  {
    text: "[GMT+05:45] Asia/Katmandu",
    value: "Asia/Katmandu",
  },
  {
    text: "[GMT+05:30] Asia/Kolkata",
    value: "Asia/Kolkata",
  },
  {
    text: "[GMT+05:00] Asia/Oral",
    value: "Asia/Oral",
  },
  {
    text: "[GMT+05:00] Asia/Samarkand",
    value: "Asia/Samarkand",
  },
  {
    text: "[GMT+05:00] Asia/Tashkent",
    value: "Asia/Tashkent",
  },
  {
    text: "[GMT+05:00] Asia/Yekaterinburg",
    value: "Asia/Yekaterinburg",
  },
  {
    text: "[GMT+05:00] Indian/Kerguelen",
    value: "Indian/Kerguelen",
  },
  {
    text: "[GMT+05:00] Indian/Maldives",
    value: "Indian/Maldives",
  },
  {
    text: "[GMT+06:00] Antarctica/Vostok",
    value: "Antarctica/Vostok",
  },
  {
    text: "[GMT+06:00] Asia/Almaty",
    value: "Asia/Almaty",
  },
  {
    text: "[GMT+06:00] Asia/Bishkek",
    value: "Asia/Bishkek",
  },
  {
    text: "[GMT+06:00] Asia/Dacca",
    value: "Asia/Dacca",
  },
  {
    text: "[GMT+06:00] Asia/Dhaka",
    value: "Asia/Dhaka",
  },
  {
    text: "[GMT+06:00] Asia/Kashgar",
    value: "Asia/Kashgar",
  },
  {
    text: "[GMT+06:00] Asia/Omsk",
    value: "Asia/Omsk",
  },
  {
    text: "[GMT+06:00] Asia/Qyzylorda",
    value: "Asia/Qyzylorda",
  },
  {
    text: "[GMT+06:30] Asia/Rangoon",
    value: "Asia/Rangoon",
  },
  {
    text: "[GMT+06:00] Asia/Thimbu",
    value: "Asia/Thimbu",
  },
  {
    text: "[GMT+06:00] Asia/Thimphu",
    value: "Asia/Thimphu",
  },
  {
    text: "[GMT+06:00] Asia/Urumqi",
    value: "Asia/Urumqi",
  },
  {
    text: "[GMT+06:30] Asia/Yangon",
    value: "Asia/Yangon",
  },
  {
    text: "[GMT+06:00] Indian/Chagos",
    value: "Indian/Chagos",
  },
  {
    text: "[GMT+06:30] Indian/Cocos",
    value: "Indian/Cocos",
  },
  {
    text: "[GMT+07:00] Antarctica/Davis",
    value: "Antarctica/Davis",
  },
  {
    text: "[GMT+07:00] Asia/Bangkok",
    value: "Asia/Bangkok",
  },
  {
    text: "[GMT+07:00] Asia/Barnaul",
    value: "Asia/Barnaul",
  },
  {
    text: "[GMT+07:00] Asia/Ho_Chi_Minh",
    value: "Asia/Ho_Chi_Minh",
  },
  {
    text: "[GMT+07:00] Asia/Hovd",
    value: "Asia/Hovd",
  },
  {
    text: "[GMT+07:00] Asia/Jakarta",
    value: "Asia/Jakarta",
  },
  {
    text: "[GMT+07:00] Asia/Krasnoyarsk",
    value: "Asia/Krasnoyarsk",
  },
  {
    text: "[GMT+07:00] Asia/Novokuznetsk",
    value: "Asia/Novokuznetsk",
  },
  {
    text: "[GMT+07:00] Asia/Novosibirsk",
    value: "Asia/Novosibirsk",
  },
  {
    text: "[GMT+07:00] Asia/Phnom_Penh",
    value: "Asia/Phnom_Penh",
  },
  {
    text: "[GMT+07:00] Asia/Pontianak",
    value: "Asia/Pontianak",
  },
  {
    text: "[GMT+07:00] Asia/Saigon",
    value: "Asia/Saigon",
  },
  {
    text: "[GMT+07:00] Asia/Tomsk",
    value: "Asia/Tomsk",
  },
  {
    text: "[GMT+07:00] Asia/Vientiane",
    value: "Asia/Vientiane",
  },
  {
    text: "[GMT+07:00] Indian/Christmas",
    value: "Indian/Christmas",
  },
  {
    text: "[GMT+08:00] Antarctica/Casey",
    value: "Antarctica/Casey",
  },
  {
    text: "[GMT+08:00] Asia/Brunei",
    value: "Asia/Brunei",
  },
  {
    text: "[GMT+08:00] Asia/Choibalsan",
    value: "Asia/Choibalsan",
  },
  {
    text: "[GMT+08:00] Asia/Chongqing",
    value: "Asia/Chongqing",
  },
  {
    text: "[GMT+08:00] Asia/Chungking",
    value: "Asia/Chungking",
  },
  {
    text: "[GMT+08:00] Asia/Harbin",
    value: "Asia/Harbin",
  },
  {
    text: "[GMT+08:00] Asia/Hong_Kong",
    value: "Asia/Hong_Kong",
  },
  {
    text: "[GMT+08:00] Asia/Irkutsk",
    value: "Asia/Irkutsk",
  },
  {
    text: "[GMT+08:00] Asia/Kuala_Lumpur",
    value: "Asia/Kuala_Lumpur",
  },
  {
    text: "[GMT+08:00] Asia/Kuching",
    value: "Asia/Kuching",
  },
  {
    text: "[GMT+08:00] Asia/Macao",
    value: "Asia/Macao",
  },
  {
    text: "[GMT+08:00] Asia/Macau",
    value: "Asia/Macau",
  },
  {
    text: "[GMT+08:00] Asia/Makassar",
    value: "Asia/Makassar",
  },
  {
    text: "[GMT+08:00] Asia/Manila",
    value: "Asia/Manila",
  },
  {
    text: "[GMT+08:00] Asia/Shanghai",
    value: "Asia/Shanghai",
  },
  {
    text: "[GMT+08:00] Asia/Singapore",
    value: "Asia/Singapore",
  },
  {
    text: "[GMT+08:00] Asia/Taipei",
    value: "Asia/Taipei",
  },
  {
    text: "[GMT+08:00] Asia/Ujung_Pandang",
    value: "Asia/Ujung_Pandang",
  },
  {
    text: "[GMT+08:00] Asia/Ulaanbaatar",
    value: "Asia/Ulaanbaatar",
  },
  {
    text: "[GMT+08:00] Asia/Ulan_Bator",
    value: "Asia/Ulan_Bator",
  },
  {
    text: "[GMT+08:45] Australia/Eucla",
    value: "Australia/Eucla",
  },
  {
    text: "[GMT+08:00] Australia/Perth",
    value: "Australia/Perth",
  },
  {
    text: "[GMT+08:00] Australia/West",
    value: "Australia/West",
  },
  {
    text: "[GMT+09:00] Asia/Chita",
    value: "Asia/Chita",
  },
  {
    text: "[GMT+09:00] Asia/Dili",
    value: "Asia/Dili",
  },
  {
    text: "[GMT+09:00] Asia/Jayapura",
    value: "Asia/Jayapura",
  },
  {
    text: "[GMT+09:00] Asia/Khandyga",
    value: "Asia/Khandyga",
  },
  {
    text: "[GMT+09:00] Asia/Pyongyang",
    value: "Asia/Pyongyang",
  },
  {
    text: "[GMT+09:00] Asia/Seoul",
    value: "Asia/Seoul",
  },
  {
    text: "[GMT+09:00] Asia/Tokyo",
    value: "Asia/Tokyo",
  },
  {
    text: "[GMT+09:00] Asia/Yakutsk",
    value: "Asia/Yakutsk",
  },
  {
    text: "[GMT+09:30] Australia/Darwin",
    value: "Australia/Darwin",
  },
  {
    text: "[GMT+09:30] Australia/North",
    value: "Australia/North",
  },
  {
    text: "[GMT+09:00] Pacific/Palau",
    value: "Pacific/Palau",
  },
  {
    text: "[GMT+10:00] Antarctica/DumontDUrville",
    value: "Antarctica/DumontDUrville",
  },
  {
    text: "[GMT+10:00] Asia/Ust-Nera",
    value: "Asia/Ust-Nera",
  },
  {
    text: "[GMT+10:00] Asia/Vladivostok",
    value: "Asia/Vladivostok",
  },
  {
    text: "[GMT+10:30] Australia/Adelaide",
    value: "Australia/Adelaide",
  },
  {
    text: "[GMT+10:00] Australia/Brisbane",
    value: "Australia/Brisbane",
  },
  {
    text: "[GMT+10:30] Australia/Broken_Hill",
    value: "Australia/Broken_Hill",
  },
  {
    text: "[GMT+10:00] Australia/Lindeman",
    value: "Australia/Lindeman",
  },
  {
    text: "[GMT+10:00] Australia/Queensland",
    value: "Australia/Queensland",
  },
  {
    text: "[GMT+10:30] Australia/South",
    value: "Australia/South",
  },
  {
    text: "[GMT+10:30] Australia/Yancowinna",
    value: "Australia/Yancowinna",
  },
  {
    text: "[GMT+10:00] Pacific/Chuuk",
    value: "Pacific/Chuuk",
  },
  {
    text: "[GMT+10:00] Pacific/Guam",
    value: "Pacific/Guam",
  },
  {
    text: "[GMT+10:00] Pacific/Port_Moresby",
    value: "Pacific/Port_Moresby",
  },
  {
    text: "[GMT+10:00] Pacific/Saipan",
    value: "Pacific/Saipan",
  },
  {
    text: "[GMT+10:00] Pacific/Truk",
    value: "Pacific/Truk",
  },
  {
    text: "[GMT+10:00] Pacific/Yap",
    value: "Pacific/Yap",
  },
  {
    text: "[GMT+11:00] Antarctica/Macquarie",
    value: "Antarctica/Macquarie",
  },
  {
    text: "[GMT+11:00] Asia/Magadan",
    value: "Asia/Magadan",
  },
  {
    text: "[GMT+11:00] Asia/Sakhalin",
    value: "Asia/Sakhalin",
  },
  {
    text: "[GMT+11:00] Asia/Srednekolymsk",
    value: "Asia/Srednekolymsk",
  },
  {
    text: "[GMT+11:00] Australia/ACT",
    value: "Australia/ACT",
  },
  {
    text: "[GMT+11:00] Australia/Canberra",
    value: "Australia/Canberra",
  },
  {
    text: "[GMT+11:00] Australia/Currie",
    value: "Australia/Currie",
  },
  {
    text: "[GMT+11:00] Australia/Hobart",
    value: "Australia/Hobart",
  },
  {
    text: "[GMT+11:00] Australia/LHI",
    value: "Australia/LHI",
  },
  {
    text: "[GMT+11:00] Australia/Lord_Howe",
    value: "Australia/Lord_Howe",
  },
  {
    text: "[GMT+11:00] Australia/Melbourne",
    value: "Australia/Melbourne",
  },
  {
    text: "[GMT+11:00] Australia/NSW",
    value: "Australia/NSW",
  },
  {
    text: "[GMT+11:00] Australia/Sydney",
    value: "Australia/Sydney",
  },
  {
    text: "[GMT+11:00] Australia/Tasmania",
    value: "Australia/Tasmania",
  },
  {
    text: "[GMT+11:00] Australia/Victoria",
    value: "Australia/Victoria",
  },
  {
    text: "[GMT+11:00] Pacific/Bougainville",
    value: "Pacific/Bougainville",
  },
  {
    text: "[GMT+11:00] Pacific/Efate",
    value: "Pacific/Efate",
  },
  {
    text: "[GMT+11:00] Pacific/Guadalcanal",
    value: "Pacific/Guadalcanal",
  },
  {
    text: "[GMT+11:00] Pacific/Kosrae",
    value: "Pacific/Kosrae",
  },
  {
    text: "[GMT+11:00] Pacific/Norfolk",
    value: "Pacific/Norfolk",
  },
  {
    text: "[GMT+11:00] Pacific/Noumea",
    value: "Pacific/Noumea",
  },
  {
    text: "[GMT+11:00] Pacific/Pohnpei",
    value: "Pacific/Pohnpei",
  },
  {
    text: "[GMT+11:00] Pacific/Ponape",
    value: "Pacific/Ponape",
  },
  {
    text: "[GMT+12:00] Asia/Anadyr",
    value: "Asia/Anadyr",
  },
  {
    text: "[GMT+12:00] Asia/Kamchatka",
    value: "Asia/Kamchatka",
  },
  {
    text: "[GMT+12:00] Pacific/Fiji",
    value: "Pacific/Fiji",
  },
  {
    text: "[GMT+12:00] Pacific/Funafuti",
    value: "Pacific/Funafuti",
  },
  {
    text: "[GMT+12:00] Pacific/Kwajalein",
    value: "Pacific/Kwajalein",
  },
  {
    text: "[GMT+12:00] Pacific/Majuro",
    value: "Pacific/Majuro",
  },
  {
    text: "[GMT+12:00] Pacific/Nauru",
    value: "Pacific/Nauru",
  },
  {
    text: "[GMT+12:00] Pacific/Tarawa",
    value: "Pacific/Tarawa",
  },
  {
    text: "[GMT+12:00] Pacific/Wake",
    value: "Pacific/Wake",
  },
  {
    text: "[GMT+12:00] Pacific/Wallis",
    value: "Pacific/Wallis",
  },
  {
    text: "[GMT+13:00] Antarctica/McMurdo",
    value: "Antarctica/McMurdo",
  },
  {
    text: "[GMT+13:00] Antarctica/South_Pole",
    value: "Antarctica/South_Pole",
  },
  {
    text: "[GMT+13:00] Pacific/Auckland",
    value: "Pacific/Auckland",
  },
  {
    text: "[GMT+13:45] Pacific/Chatham",
    value: "Pacific/Chatham",
  },
  {
    text: "[GMT+13:00] Pacific/Enderbury",
    value: "Pacific/Enderbury",
  },
  {
    text: "[GMT+13:00] Pacific/Fakaofo",
    value: "Pacific/Fakaofo",
  },
  {
    text: "[GMT+13:00] Pacific/Tongatapu",
    value: "Pacific/Tongatapu",
  },
  {
    text: "[GMT+14:00] Pacific/Apia",
    value: "Pacific/Apia",
  },
  {
    text: "[GMT+14:00] Pacific/Kiritimati",
    value: "Pacific/Kiritimati",
  },
];
